import React from "react";
import { cx } from "../../lib/cx";

export type ScanStatus = "ok" | "partial" | "error" | "running" | "pending";
export type FindingStatus = "open" | "fixed" | "suppressed";

const scanStatusConfig: Record<
  ScanStatus,
  { label: string; dotClass: string; badgeClass: string }
> = {
  ok: {
    label: "OK",
    dotClass: "bg-success",
    badgeClass: "badge-success",
  },
  partial: {
    label: "Partial",
    dotClass: "bg-warning",
    badgeClass: "badge-warning",
  },
  error: {
    label: "Error",
    dotClass: "bg-danger",
    badgeClass: "badge-danger",
  },
  running: {
    label: "Running",
    dotClass: "bg-info animate-pulse",
    badgeClass: "badge-info",
  },
  pending: {
    label: "Pending",
    dotClass: "bg-sev-info",
    badgeClass: "badge-info",
  },
};

const findingStatusConfig: Record<
  FindingStatus,
  { label: string; dotClass: string; badgeClass: string }
> = {
  open: {
    label: "Open",
    dotClass: "bg-warning",
    badgeClass: "badge-warning",
  },
  fixed: {
    label: "Fixed",
    dotClass: "bg-success",
    badgeClass: "badge-success",
  },
  suppressed: {
    label: "Suppressed",
    dotClass: "bg-sev-info",
    badgeClass: "badge-info",
  },
};

interface ScanStatusBadgeProps {
  status: ScanStatus;
  className?: string;
}

export function ScanStatusBadge({ status, className }: ScanStatusBadgeProps) {
  const config = scanStatusConfig[status] || scanStatusConfig.pending;

  return (
    <span className={cx("badge", config.badgeClass, className)}>
      <span className={cx("h-1.5 w-1.5 rounded-full", config.dotClass)} />
      {config.label}
    </span>
  );
}

interface FindingStatusBadgeProps {
  status: FindingStatus;
  className?: string;
}

export function FindingStatusBadge({
  status,
  className,
}: FindingStatusBadgeProps) {
  const config = findingStatusConfig[status] || findingStatusConfig.open;

  return (
    <span className={cx("badge", config.badgeClass, className)}>
      <span className={cx("h-1.5 w-1.5 rounded-full", config.dotClass)} />
      {config.label}
    </span>
  );
}
